(() => {
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => [...r.querySelectorAll(s)];
  const V = window.VEYR || {};
  const esc = s => String(s ?? '').replace(/[&<>"']/g, c => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  function money(cents) {
    const fmt = V.moneyFormat || '${{amount}}';
    const n = (cents / 100);
    const withDelims = (d, t, dec) => { const [a, b] = n.toFixed(d).split('.'); return a.replace(/\B(?=(\d{3})+(?!\d))/g, t) + (b ? dec + b : ''); };
    return fmt.replace(/\{\{\s*(\w+)\s*\}\}/, (_, k) => k === 'amount_no_decimals' ? withDelims(0, ',', '.') : k === 'amount_with_comma_separator' ? withDelims(2, '.', ',') : withDelims(2, ',', '.'));
  }
  const store = { get(k, d) { try { const v = localStorage.getItem('veyr.' + k); return v ? JSON.parse(v) : d; } catch (e) { return d; } }, set(k, v) { try { localStorage.setItem('veyr.' + k, JSON.stringify(v)); } catch (e) {} } };

  function toast(t) { const el = $('#toast'); if (!el) return; $('#toastT').textContent = t; el.classList.add('on'); clearTimeout(toast.t); toast.t = setTimeout(() => el.classList.remove('on'), 2600); }

  /* overlays */
  function closeAll() { $$('.drawer.on,.modal.on,.search.on').forEach(e => e.classList.remove('on')); $('#scrim')?.classList.remove('on'); $('#mnav')?.classList.remove('open'); }
  function open(id) { closeAll(); $('#' + id)?.classList.add('on'); $('#scrim')?.classList.add('on'); }
  $('#scrim')?.addEventListener('click', closeAll);
  document.addEventListener('keydown', e => { if (e.key === 'Escape') closeAll(); });
  $('#burger')?.addEventListener('click', () => $('#mnav').classList.add('open'));
  $('#mclose')?.addEventListener('click', closeAll);

  /* announcement */
  const ann = $$('.announce span'); let ai = 0;
  if (ann.length > 1) setInterval(() => { ann[ai].classList.remove('on'); ai = (ai + 1) % ann.length; ann[ai].classList.add('on'); }, 4500);

  /* film */
  const film = $('#heroFilm'), ft = $('#filmToggle');
  ft?.addEventListener('click', () => {
    if (film.paused) { film.play(); $('#filmIcon').innerHTML = '<rect x="2" y="1" width="2.6" height="10"/><rect x="7.4" y="1" width="2.6" height="10"/>'; ft.ariaLabel = 'Pause film'; }
    else { film.pause(); $('#filmIcon').innerHTML = '<path d="M3 1l8 5-8 5Z"/>'; ft.ariaLabel = 'Play film'; }
  });
  if (matchMedia('(prefers-reduced-motion: reduce)').matches) $$('video').forEach(v => v.pause());

  /* ---------- cart drawer ---------- */
  const setCount = n => { const c = $('#bagCount'); if (c) { c.textContent = n; c.dataset.n = n; } };
  async function getCart() { const r = await fetch(V.routes.cart, { headers: { Accept: 'application/json' } }); return r.json(); }
  function renderCart(cart) {
    setCount(cart.item_count);
    const body = $('#bagBody'), foot = $('#bagFoot'); if (!body) return;
    if (!cart.item_count) {
      body.innerHTML = `<div class="empty"><h4>Your bag is empty</h4><p class="muted">Begin with the piece the House is known for.</p><a class="btn btn-dark" href="/collections/all">Discover the Collection</a></div>`;
      foot.hidden = true; return;
    }
    body.innerHTML = cart.items.map((it, i) => `<div class="line-item"><a class="thumb" href="${esc(it.url)}">${it.image ? `<img src="${esc(it.image)}&width=240" alt="">` : ''}</a><div>
      <div class="t"><a class="n" href="${esc(it.url)}">${esc(it.product_title)}</a><span class="price">${money(it.final_line_price)}</span></div>
      ${it.product_has_only_default_variant ? '' : `<div class="v">${esc(it.variant_title)}</div>`}
      <div><span class="qty"><button data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="Decrease">−</button><span>${it.quantity}</span><button data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="Increase">+</button></span><button class="rm" data-line="${i + 1}" data-qty="0">Remove</button></div></div></div>`).join('');
    const left = V.freeShip - cart.total_price;
    renderNudge(cart, left);
    foot.hidden = false;
    foot.innerHTML = `<div><div class="muted">${left > 0 ? `You're ${money(left)} away from complimentary NZ & AU delivery` : "You've unlocked complimentary NZ & AU delivery"}</div><div class="ship-bar"><i style="width:${Math.min(100, cart.total_price / V.freeShip * 100)}%"></i></div></div>
      ${cart.total_discount > 0 ? `<div class="row bag-save"><span>Multi-buy saving</span><span>−${money(cart.total_discount)}</span></div>` : ''}<div class="row total"><span>Subtotal</span><span>${money(cart.total_price)}</span></div><div class="muted">Delivery and promo codes at checkout.</div><div class="muted">or 4 interest-free payments of ${money(Math.round(cart.total_price / 4))} with <span class="ap-mark">afterpay</span></div>
      <a class="btn btn-dark" href="${V.routes.checkout}"><svg width="14" height="14" style="stroke:currentColor;fill:none"><use href="#i-lock"/></svg>Secure checkout</a>
      <a class="link" style="justify-self:center" href="${V.routes.cartUrl}">View bag</a>`;
  }

  /* ---------- free-delivery nudge: suggest a tee ---------- */
  let teeCache = null;
  async function renderNudge(cart, left) {
    const body = $('#bagBody'); if (!body || left <= 0) return;
    try {
      if (!teeCache) { const r = await fetch('/collections/t-shirts/products.json?limit=24'); teeCache = (await r.json()).products || []; }
      const inBag = new Set(cart.items.map(i => i.product_id));
      const tee = teeCache.find(p => !inBag.has(p.id) && p.variants.some(v => v.available)) || teeCache.find(p => p.variants.some(v => v.available));
      if (!tee || $('#bagBody .nudge')) return;
      const teesIn = cart.items.filter(i => (i.product_type || '').toLowerCase() === 't-shirt').reduce((a, i) => a + i.quantity, 0);
      const adds = teesIn === 0 ? 3699 : teesIn === 1 ? 2699 : 3199;
      const reaches = left <= adds;
      const head = teesIn === 0
        ? (reaches ? 'Add a tee for $36.99 and your delivery is free' : `Add a tee for $36.99. You'll be ${money(left - adds)} from free delivery`)
        : (reaches ? 'Add another tee, two are $31.99 each, and your delivery is free' : 'Add another tee, two are $31.99 each');
      const img = tee.images && tee.images[0] ? tee.images[0].src : '';
      const n = document.createElement('div'); n.className = 'nudge';
      n.innerHTML = `<div class="nudge-top"><span class="nudge-tag">Free delivery</span><p>${esc(head)}</p></div>
        <div class="nudge-row">${img ? `<a href="/products/${esc(tee.handle)}"><img src="${esc(img)}&width=160" alt=""></a>` : ''}
          <div><a class="n" href="/products/${esc(tee.handle)}">${esc(tee.title)}</a>
          <div class="nudge-sizes">${tee.variants.map(v => `<button type="button" data-quick-add="${v.id}" ${v.available ? '' : 'disabled'} aria-label="Add ${esc(tee.title)} size ${esc(v.title)}">${esc(v.title)}</button>`).join('')}</div></div></div>`;
      body.appendChild(n);
    } catch (e) {}
  }
  async function openBag() { open('bag'); renderCart(await getCart()); }
  $('#openBag')?.addEventListener('click', e => { if (document.body.classList.contains('template-cart')) return; e.preventDefault(); openBag(); });

  async function addToCart(fd) {
    const r = await fetch(V.routes.cartAdd, { method: 'POST', headers: { Accept: 'application/json' }, body: fd });
    const j = await r.json();
    if (!r.ok) { toast(j.description || 'This piece could not be added'); return false; }
    toast(`${j.product_title || 'Piece'} added to your bag`); await openBag(); checkNudge(); return true;
  }
  async function changeLine(line, quantity) {
    const r = await fetch(V.routes.cartChange, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ line, quantity }) });
    renderCart(await r.json());
  }

  /* ---------- wishlist ---------- */
  let wish = store.get('wish', []);
  const wCount = () => { const c = $('#wishCount'); if (c) { c.textContent = wish.length; c.dataset.n = wish.length; } $$('[data-wish]').forEach(b => b.classList.toggle('on', wish.some(w => w.h === b.dataset.wish))); };
  function renderWish() {
    $('#wishBody').innerHTML = wish.length ? wish.map(w => `<div class="line-item"><a class="thumb" href="${esc(w.u)}">${w.i ? `<img src="${esc(w.i)}" alt="">` : ''}</a><div><div class="t"><a class="n" href="${esc(w.u)}">${esc(w.t)}</a><span class="price">${esc(w.p)}</span></div><div style="margin-top:12px"><a class="link" href="${esc(w.u)}">View piece</a><button class="rm" data-unwish="${esc(w.h)}">Remove</button></div></div></div>`).join('')
      : `<div class="empty"><h4>Nothing saved yet</h4><p class="muted">Tap the heart on any piece to keep it here.</p><a class="btn btn-ghost" href="/collections/all">Browse the collection</a></div>`;
  }
  $('#openWish')?.addEventListener('click', () => { open('wish'); renderWish(); });
  wCount();

  /* ---------- predictive search ---------- */
  const q = $('#q');
  $('#openSearch')?.addEventListener('click', () => { open('search'); setTimeout(() => q?.focus(), 300); });
  let st;
  async function search() {
    const term = q.value.trim(); const res = $('#qres');
    if (!term) { res.innerHTML = ''; return; }
    try {
      const r = await fetch(`${V.routes.search}?q=${encodeURIComponent(term)}&resources[type]=product&resources[limit]=8`);
      const j = await r.json(); const ps = j.resources?.results?.products || [];
      res.innerHTML = ps.length ? ps.map(p => `<a href="${esc(p.url)}"><span class="mini">${p.image ? `<img src="${esc(p.image)}" alt="" style="width:100%;height:100%;object-fit:cover">` : ''}</span><span><span style="font-family:var(--display);font-size:16px">${esc(p.title)}</span><br><span class="muted">${p.price ? money(Math.round(parseFloat(p.price) * 100)) : ''}</span></span></a>`).join('')
        : `<p class="muted">No pieces match “${esc(term)}”. Try “vest” or “cotton”.</p>`;
    } catch (e) { res.innerHTML = ''; }
  }
  q?.addEventListener('input', () => { clearTimeout(st); st = setTimeout(search, 220); });

  /* ---------- global clicks ---------- */
  document.addEventListener('click', async e => {
    const t = e.target.closest('[data-wish],[data-unwish],[data-quick-add],[data-line],[data-close],[data-act],[data-sug]');
    if (!t) return;
    if (t.dataset.wish) {
      e.preventDefault(); const h = t.dataset.wish; const i = wish.findIndex(w => w.h === h);
      if (i > -1) { wish.splice(i, 1); toast('Removed from wishlist'); } else { wish.push({ h, t: t.dataset.title, u: t.dataset.url, p: t.dataset.price, i: t.dataset.img }); toast('Saved to your wishlist'); }
      store.set('wish', wish); wCount();
    } else if (t.dataset.unwish) { wish = wish.filter(w => w.h !== t.dataset.unwish); store.set('wish', wish); wCount(); renderWish(); }
    else if (t.dataset.quickAdd) { const fd = new FormData(); fd.append('id', t.dataset.quickAdd); fd.append('quantity', 1); t.disabled = true; await addToCart(fd); t.disabled = false; }
    else if (t.dataset.line) { changeLine(+t.dataset.line, Math.max(0, +t.dataset.qty)); }
    else if (t.dataset.act === 'size') open('sizeModal');
    else if (t.dataset.sug) { q.value = t.dataset.sug; search(); }
    else if (t.hasAttribute('data-close')) closeAll();
  });

  /* ---------- product form ---------- */
  const pform = $('#pform'), pj = $('#pJSON');
  if (pform && pj) {
    const product = JSON.parse(pj.textContent);
    const btn = $('#addBtn'), idIn = $('#pVariant');
    const current = () => $$('input[data-opt]:checked', pform).sort((a, b) => a.dataset.opt - b.dataset.opt).map(i => i.value);
    function update() {
      const sel = current();
      const v = product.variants.find(v => v.options.every((o, i) => o === sel[i]));
      sel.forEach((val, i) => { const n = $(`[data-opt-name="${i}"]`); if (n) n.textContent = val; });
      if (!v) { btn.disabled = true; btn.textContent = 'Unavailable'; return; }
      idIn.value = v.id;
      $('#pPrice').innerHTML = (v.compare_at_price > v.price ? `<span class="compare">${money(v.compare_at_price)}</span>` : '') + money(v.price);
      $('#pInst').textContent = money(Math.round(v.price / 4)); const sp = $('#stickyPrice'); if (sp) sp.textContent = money(v.price);
      btn.disabled = !v.available; btn.textContent = v.available ? 'Add to bag' : 'Sold out';
      const u = new URL(location.href); u.searchParams.set('variant', v.id); history.replaceState(null, '', u);
      // mark sold-out values for the last option given the others
      if (product.options.length) {
        const last = product.options.length - 1;
        $$(`input[data-opt="${last}"]`, pform).forEach(inp => {
          const s = [...sel]; s[last] = inp.value;
          const m = product.variants.find(x => x.options.every((o, i) => o === s[i]));
          inp.parentElement.classList.toggle('sold', !m || !m.available);
        });
      }
    }
    pform.addEventListener('change', e => { if (e.target.dataset.opt !== undefined) update(); });
    $$('[data-q]', pform).forEach(b => b.addEventListener('click', () => { const i = $('#pQty'); i.value = Math.max(1, (+i.value || 1) + +b.dataset.q); }));
    pform.addEventListener('submit', async e => {
      e.preventDefault(); btn.disabled = true; const label = btn.textContent; btn.textContent = 'Adding…';
      await addToCart(new FormData(pform)); btn.disabled = false; btn.textContent = label;
    });
    if (product.options.length) update();
  }

  /* ---------- copy link ---------- */
  document.addEventListener('click', async e => { const t = e.target.closest('[data-copy]'); if (!t) return; try { await navigator.clipboard.writeText(t.dataset.copy); toast('Link copied'); } catch (err) { toast(t.dataset.copy); } });

  /* ---------- filters drawer ---------- */
  document.addEventListener('click', e => { const t = e.target.closest('[data-open]'); if (t) { e.preventDefault(); open(t.dataset.open); } });

  /* ---------- recommendations ---------- */
  const recs = $('.product-recs');
  if (recs && recs.dataset.url && !recs.querySelector('.grid')) {
    fetch(recs.dataset.url).then(r => r.text()).then(html => {
      const d = new DOMParser().parseFromString(html, 'text/html'); const n = d.querySelector('.product-recs');
      if (n && n.innerHTML.trim()) { recs.innerHTML = n.innerHTML; wCount(); }
    }).catch(() => {});
  }

  /* ---------- recently viewed ---------- */
  const meta = $('#pMeta');
  if (meta) {
    let m; try { m = JSON.parse(meta.textContent); } catch (e) {}
    let rv = store.get('recent', []);
    const others = rv.filter(x => m && x.handle !== m.handle).slice(0, 4);
    if (others.length) {
      $('#recent').hidden = false;
      $('#recentGrid').innerHTML = others.map(x => `<article class="card"><div class="media"><a href="${esc(x.u)}" aria-label="${esc(x.t)}">${x.i ? `<img class="art" src="${esc(x.i)}" alt="${esc(x.t)}" loading="lazy">` : ''}${x.i2 ? `<img class="art alt" src="${esc(x.i2)}" alt="" loading="lazy">` : ''}</a></div><div class="info"><div><a class="name" href="${esc(x.u)}">${esc(x.t)}</a><div class="sub">${esc(x.type || '')}</div></div><span class="price">${esc(x.p)}</span></div></article>`).join('');
    }
    others.forEach(x => { fetch(String(x.u).split('?')[0] + '.js').then(r => r.ok ? r.json() : null).then(d => { const card = [...$('#recentGrid').children].find(c => (c.querySelector('a') || {}).getAttribute && c.querySelector('a').getAttribute('href') === x.u); if (!card) return; if (!d) { card.remove(); return; } const el = card.querySelector('.price'); if (el) el.textContent = '$' + (d.price / 100).toFixed(2); const nm = card.querySelector('.name'); if (nm) nm.textContent = d.title; const sb = card.querySelector('.sub'); if (sb) sb.textContent = d.type; }).catch(() => {}); }); if (m) { rv = [m, ...rv.filter(x => x.handle !== m.handle)].slice(0, 12); store.set('recent', rv); }
  }

  /* ---------- sticky buy bar (mobile) ---------- */
  const sb = $('#stickyBuy'), ab = $('#addBtn');
  if (sb && ab && 'IntersectionObserver' in window) {
    new IntersectionObserver(([en]) => sb.classList.toggle('on', !en.isIntersecting && en.boundingClientRect.top < 0)).observe(ab);
  }

  /* ---------- image zoom ---------- */
  const zo = document.createElement('div'); zo.className = 'zoom-ov'; zo.setAttribute('role', 'dialog'); zo.setAttribute('aria-label', 'Zoomed image'); document.body.appendChild(zo);
  document.addEventListener('click', e => { const z = e.target.closest('.zoomable'); if (!z) return; zo.innerHTML = `<img src="${esc(z.dataset.zoom)}" alt="">`; zo.classList.add('on'); });
  zo.addEventListener('click', () => zo.classList.remove('on'));
  document.addEventListener('keydown', e => { if (e.key === 'Escape') zo.classList.remove('on'); });

  /* ---------- delivery estimate (NZ business days) ---------- */
  const eta = $('#etaDate');
  if (eta) {
    const add = n => { const d = new Date(); let c = 0; while (c < n) { d.setDate(d.getDate() + 1); const w = d.getDay(); if (w && w !== 6) c++; } return d; };
    const f = d => d.toLocaleDateString('en-NZ', { weekday: 'short', day: 'numeric', month: 'short' });
    eta.textContent = (window.Shopify && Shopify.country === 'AU') ? `delivered by ${f(add(10))}` : `delivered ${f(add(2))} – ${f(add(5))}`;
  }

  /* ---------- sticky add ---------- */
  $('#stickyAdd')?.addEventListener('click', () => { const f = $('#pform'); if (f && !$('#addBtn').disabled) f.requestSubmit(); else $('#addBtn')?.scrollIntoView({ behavior: 'smooth', block: 'center' }); });

  /* ---------- reading progress ---------- */
  const rp = $('#readProgress');
  if (rp) { const upd = () => { const h = document.documentElement; const p = h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight); rp.style.width = (p * 100).toFixed(1) + '%'; }; addEventListener('scroll', upd, { passive: true }); upd(); }

  /* ---------- bag extras: trust row + complete the look ---------- */
  const foot = $('#bagFoot');
  if (foot) {
    new MutationObserver(async () => {
      if (foot.hidden || foot.querySelector('.bag-extras')) return;
      if (foot.dataset.busy) return; foot.dataset.busy = '1';
      const cart = await getCart(); delete foot.dataset.busy;
      if (foot.querySelector('.bag-extras')) return;
      const ex = document.createElement('div'); ex.className = 'bag-extras'; ex.hidden = true; foot.insertBefore(ex, foot.firstChild);
      const trust = document.createElement('div'); trust.className = 'bag-trust'; trust.innerHTML = '<span>Secure checkout</span><span>30-day returns</span><span>Free NZ and Australia delivery over $100</span>'; foot.appendChild(trust);
      const first = cart.items[0];
      if (first) {
        try {
          const r = await fetch(`/recommendations/products.json?product_id=${first.product_id}&limit=3`); const j = await r.json();
          const inBag = new Set(cart.items.map(i => i.product_id));
          const ps = (j.products || []).filter(p => !inBag.has(p.id)).slice(0, 2);
          if (ps.length && !$('#bagBody .upsell')) {
            const up = document.createElement('div'); up.className = 'upsell';
            up.innerHTML = '<h5>Complete the look</h5>' + ps.map(p => `<div class="u"><img src="${esc(p.featured_image)}" alt=""><span>${esc(p.title)}<br><small class="muted">${money(p.price)}</small></span><a class="link" href="${esc(p.url)}">View</a></div>`).join('');
            $('#bagBody').appendChild(up);
          }
        } catch (e) {}
      }
    }).observe(foot, { attributes: true, childList: true });
  }

  /* ---------- popups: welcome subscribe + gentle $80 nudge ---------- */
  const ss = { get(k) { try { return sessionStorage.getItem('veyr.' + k); } catch (e) { return null; } }, set(k, v) { try { sessionStorage.setItem('veyr.' + k, v); } catch (e) {} } };
  const vp = $('#vpWelcome'), vpScrim = $('#vpScrim');
  function showWelcome(thanks) {
    if (!vp) return;
    if (thanks) { $('#vpForm').hidden = true; $('#vpThanks').hidden = false; }
    vp.hidden = false; vpScrim.hidden = false; requestAnimationFrame(() => { vp.classList.add('on'); vpScrim.classList.add('on'); });
    store.set('welcomeSeen', Date.now());
  }
  function hideWelcome() { if (!vp) return; vp.classList.remove('on'); vpScrim.classList.remove('on'); setTimeout(() => { vp.hidden = true; vpScrim.hidden = true; }, 350); }
  document.addEventListener('click', e => { if (e.target.closest('[data-vp-close]') || e.target === vpScrim) hideWelcome(); });
  document.addEventListener('keydown', e => { if (e.key === 'Escape') hideWelcome(); });
  $('#vpSubForm')?.addEventListener('submit', () => store.set('subPending', 1));
  // returning from a successful sign-up
  if (/customer_posted=true/.test(location.search) && store.get('subPending', 0)) { store.set('subPending', 0); store.set('subscribed', 1); setTimeout(() => showWelcome(true), 400); }
  else if (vp && !V.subscribed && !store.get('subscribed', 0) && !/^\/(cart|checkout|account|pages\/client-services)/.test(location.pathname)) {
    const seen = +store.get('welcomeSeen', 0); const coolOff = 7 * 24 * 3600 * 1000;
    if (!seen || Date.now() - seen > coolOff) {
      let fired = false; const fire = () => { if (fired || $('.drawer.on')) return; fired = true; showWelcome(false); };
      setTimeout(fire, 18000);
      addEventListener('scroll', function onS() { const h = document.documentElement; if (h.scrollTop / Math.max(1, h.scrollHeight - h.clientHeight) > 0.45) { removeEventListener('scroll', onS); setTimeout(fire, 600); } }, { passive: true });
      document.addEventListener('mouseout', e => { if (!e.relatedTarget && e.clientY < 8) fire(); });
    }
  }
  // gentle nudge when the bag reaches $80 (but not $100)
  const vn = $('#vpNudge');
  async function checkNudge() {
    if (!vn || ss.get('nudged')) return;
    try {
      const c = await getCart(); const t = c.total_price;
      if (t >= 8000 && t < V.freeShip) {
        ss.set('nudged', 1); $('#vnLeft').textContent = money(V.freeShip - t);
        setTimeout(() => { vn.hidden = false; requestAnimationFrame(() => vn.classList.add('on')); }, 900);
      }
    } catch (e) {}
  }
  const hideNudge = () => { vn.classList.remove('on'); setTimeout(() => vn.hidden = true, 350); };
  document.addEventListener('click', e => { if (e.target.closest('[data-vn-close]')) hideNudge(); });
  $('#vnYes')?.addEventListener('click', () => { hideNudge(); if ($('#bagBody .nudge')) { open('bag'); $('#bagBody .nudge').scrollIntoView({ behavior: 'smooth', block: 'center' }); } else location.href = '/collections/t-shirts'; });
})();
